import AuthHelpers from "@/helpers/AuthHelpers";
import { startTransition } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useData } from "@/stores/data";
import { userRole } from "@/helpers/h";
import {
  Dropdown,
  DropdownContent,
  DropdownTrigger,
} from "@/components/ui/dropdown";
import { Menu, User, ChevronDown, LogOut, ArrowRight } from "lucide-react";
import NavbarNotifications from "./NavbarNotifications";

export default function Navbar() {
  const navigate = useNavigate();

  const {
    sidebarState,
    setSidebarState,
    sidebarMinMax,
    setSidebarMinMax,
    setting,
  } = useData();

  const handleLogout = () => {
    AuthHelpers.auth_logout();
    useData.setState({ isAuth: false });
    startTransition(() => {
      navigate("/auth/login");
    });
  };

  return (
    <div className="fixed top-0 left-0 w-full z-[10]">
      <nav className="flex justify-between items-center bg-white/95 backdrop-blur-md border-b border-gray-200/50 px-6 h-20 w-screen shadow-sm">
        <div className="flex items-center gap-4">
          {userRole() == "service_engineer" ||
          userRole() == "first_level_maintenance" ||
          userRole() == "cash_in_transit" ||
          userRole() == "comm_vendor" ||
          userRole() == "manager" ||
          userRole() == "team_leader" ? null : (
            <button
              className="xl:hidden block p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
              onClick={() => {
                setSidebarState(!sidebarState);
              }}
            >
              <Menu className="w-5 h-5 text-gray-600" />
            </button>
          )}

          <div className="flex items-center gap-3">
            <img
              src={
                setting?.logo_url ? setting.logo_url : "/src/assets/bts_new.png"
              }
              alt="logo"
              className="h-10"
            />
            <div className="flex-col lg:flex hidden">
              <span className="text-lg font-bold text-gray-900">
                {setting?.title || "BTS"}
              </span>
              <span className="text-xs text-gray-500 font-medium">
                {setting?.description || "Brinks Ticketing System"}
              </span>
            </div>
          </div>

          {userRole() == "service_engineer" ||
          userRole() == "first_level_maintenance" ||
          userRole() == "cash_in_transit" ||
          userRole() == "comm_vendor" ||
          userRole() == "manager" ||
          userRole() == "team_leader" ? null : (
            <button
              className="xl:block hidden ml-8 p-2 rounded-lg hover:bg-gray-100 transition-all duration-200 group"
              onClick={() => {
                setSidebarMinMax(!sidebarMinMax);
              }}
            >
              <ArrowRight
                className={`h-5 w-5 text-gray-600 transition-all duration-300 group-hover:text-blue-600 ${
                  sidebarMinMax ? "rotate-0" : "rotate-180"
                }`}
              />
            </button>
          )}
        </div>
        <div className="flex items-center gap-4">
          <NavbarNotifications />

          {/* User Profile */}
          <Dropdown className="relative">
            <DropdownTrigger>
              <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 group cursor-pointer">
                <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
                  <span className="text-white font-semibold text-sm">
                    {AuthHelpers.auth_name()?.charAt(0)?.toUpperCase()}
                  </span>
                </div>
                <div className="hidden md:block">
                  <h3 className="text-sm font-semibold text-gray-900">
                    {AuthHelpers.auth_name()}
                  </h3>
                  <p className="text-xs text-gray-500 truncate max-w-32">
                    {AuthHelpers.auth_email()}
                  </p>
                </div>
                <ChevronDown className="w-4 h-4 text-gray-400 group-hover:text-gray-600 transition-colors" />
              </div>
            </DropdownTrigger>
            <DropdownContent>
              <div className="w-64 bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden">
                <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
                  <h3 className="font-semibold text-gray-900">
                    {AuthHelpers.auth_name()}
                  </h3>
                  <p className="text-sm text-gray-500">
                    {AuthHelpers.auth_email()}
                  </p>
                </div>
                <div className="py-2">
                  <Link
                    to="/profile"
                    className="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                  >
                    <User className="w-4 h-4 text-gray-400" />
                    Profile Settings
                  </Link>
                  <div className="border-t border-gray-100 my-1"></div>
                  <button
                    onClick={handleLogout}
                    className="flex items-center gap-3 px-4 py-3 text-sm text-red-600 hover:bg-red-50 transition-colors w-full text-left"
                  >
                    <LogOut className="w-4 h-4 text-red-400" />
                    Sign Out
                  </button>
                </div>
              </div>
            </DropdownContent>
          </Dropdown>
        </div>
      </nav>
    </div>
  );
}
